export const DEFAULT_LOCALE = 'en-US'

export const getNavigatorLocale = (): string => {
  try {
    const allLanguages = [...navigator.languages, navigator.language].filter(
      Boolean
    )
    if (allLanguages.length > 0) {
      for (const locale of allLanguages) {
        try {
          const rawLocale = locale.split(';')[0].trim()
          return Intl.getCanonicalLocales(rawLocale)[0]
        } catch {
          // Ignore invalid locales
        }
      }
    }
    console.warn(
      `No valid navigator locale found, using default locale ${DEFAULT_LOCALE}`
    )
    return DEFAULT_LOCALE
  } catch (error) {
    console.error('Unable to determine navigator locale', error)
    return DEFAULT_LOCALE
  }
}
